import { Component } from '@angular/core';

@Component({
  selector: 'uni-filter-bar-item',
  templateUrl: './uni-filter-bar-item.component.html',
  styleUrls: ['./uni-filter-bar-item.component.scss'],
})
export class UniFilterBarItemComponent {}
